import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: 720,
    maxWidth: '100%'
  },
  modalHeader: {
    marginBottom: theme.spacing(6)
  },
  issuesSection: {
    width: '100%',
    '& + &': {
      marginTop: theme.spacing(6)
    }
  },
  sectionHeadingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.colorPalette.green_75
  },
  countChip: {
    backgroundColor: theme.colorPalette.beige_40,
    color: theme.colorPalette.green_75
  },
  sectionSubtitle: {
    display: 'block',
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.green_80,
    marginBottom: theme.spacing(4)
  },
  errorCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%'
  },
  errorCard: {
    backgroundColor: theme.colorPalette.beige_40,
    borderRadius: theme.sizes.roundCorners,
    // Per designer PR feedback (Jun 16): 24px from the card edge to the card name, and a 1px
    // transparent border so the clickable card's hover border (below) doesn't shift layout.
    padding: theme.spacing(3),
    border: '1px solid transparent'
  },
  blockingCard: {
    backgroundColor: theme.colorPalette.red_100_10
  },
  blockingCardTitle: {
    color: theme.colorPalette.red_100
  },
  blockedIcon: {
    width: 24,
    height: 24
  },
  cardTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    // 16px gap from the card name down to the separating line (designer PR feedback, Jun 16).
    marginBottom: theme.spacing(2)
  },
  warningIcon: {
    width: 24,
    height: 24
  },
  cardTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.colorPalette.green_75
  },
  // Visual cue only — the whole card is the click target (see clickableCard).
  goToArrow: {
    width: 24,
    height: 24
  },
  // Applied to the error card when it's clickable (has a scroll anchor). Resets the native
  // <button> chrome so the card looks identical to a static one, then adds the hover affordance.
  // Per designer PR feedback (Jun 16) the hover is intentionally subtle: keep the fill, add our
  // "shadow1" (0 2px 2px rgba(0,0,0,0.1) — the same elevation used on cards/buttons) and a 1px
  // beige_60 (#ddd1c0) border. The base errorCard already reserves a 1px transparent border so
  // this doesn't shift layout on hover.
  clickableCard: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    font: 'inherit',
    cursor: 'pointer',
    transition: 'box-shadow 0.15s ease-in-out, border-color 0.15s ease-in-out',
    '&:hover': {
      borderColor: theme.colorPalette.beige_60,
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.1)'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.colorPalette.orange_50}`,
      outlineOffset: 2
    }
  },
  goToTooltip: {
    backgroundColor: theme.colorPalette.green_75,
    fontSize: 14
  },
  errorItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    borderTop: `1px solid ${theme.colorPalette.beige_50}`,
    // 16px above (matching the name→line gap) and below — keeps each error row as tight as the
    // design's 53px row instead of the looser 32px padding it had before (designer PR feedback).
    padding: theme.spacing(2, 0)
  },
  errorFieldLabel: {
    display: 'block',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    color: theme.colorPalette.green_90
  },
  errorMessage: {
    display: 'block',
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colorPalette.green_80
  }
}));

export default useStyles;
